<template>
  <q-list bordered class="rounded-borders">
    <q-expansion-item v-model="expanded" header-class="bg-grey-4 text-bold" header-style="font-size: 21px"
                      icon="info" label="Provider Details" v-if="selected_plan">

      <q-card>

        <q-card-section class="text-100 text-grey-10">
          <div>
            {{ plan_brand_legal_name(selected_plan) }}
          </div>
          <div>
            {{ plan_brand_address(selected_plan) }}
          </div>
          <div>
            PUCT Certificate Number #{{ plan_brand_puct(selected_plan) }}
          </div>
          <div>
            {{ plan_brand_support_email(selected_plan) }}
          </div>
          <div>
            {{ plan_brand_website(selected_plan) }}
          </div>
          <div>
            <a :href="`tel:${plan_phone_number(selected_plan)}`">{{ plan_phone_number(selected_plan) }}</a>
            {{ plan_hours_string(selected_plan) }}
          </div>

          <!--          <div class="flex q-gutter-x-sm text-0875">-->
          <!--            <div class="text-blue-grey-6"> Provider Name:</div>-->
          <!--            <div class="text-bold">{{ plan_brand_legal_name(selected_plan) }}</div>-->
          <!--          </div>-->

          <!--          <div class="flex q-gutter-x-sm text-0875">-->
          <!--            <div class="text-blue-grey-6"> Provider Address:</div>-->
          <!--            <div class="text-bold">{{ plan_brand_address(selected_plan) }}</div>-->
          <!--          </div>-->

          <!--          <div class="flex q-gutter-x-sm text-0875">-->
          <!--            <div class="text-blue-grey-6"> Provider Email:</div>-->
          <!--            <div class="text-bold">{{ plan_brand_support_email(selected_plan) }}</div>-->
          <!--          </div>-->

          <!--          <div class="flex q-gutter-x-sm text-0875">-->
          <!--            <div class="text-blue-grey-6"> Provider Website:</div>-->
          <!--            <div class="text-bold">{{ plan_brand_website(selected_plan) }}</div>-->
          <!--          </div>-->

          <!--          <div class="flex q-gutter-x-sm text-0875">-->
          <!--            <div class="text-blue-grey-6"> Provider Phone:</div>-->
          <!--            <a :href="`tel:${plan_phone_number(selected_plan)}`">{{ plan_phone_number(selected_plan) }}</a>-->
          <!--            <div class="text-bold">-->
          <!--              {{ plan_hours_string(selected_plan) }}-->
          <!--            </div>-->
          <!--          </div>-->

          <!--          <div class="flex q-gutter-x-sm text-0875">-->
          <!--            <div class="text-blue-grey-6"> PUCT Certificate Number:</div>-->
          <!--            <div class="text-bold">{{ plan_brand_puct(selected_plan) }}</div>-->
          <!--          </div>-->
        </q-card-section>

      </q-card>

    </q-expansion-item>
  </q-list>
</template>

<script>
import SelectedPlan from "src/composables/SelectedPlan";
import Utilities from "src/composables/Utilities";
import { ref } from "vue";

export default {
  name: "ProviderDetailsCard",
  setup() {
    const { selected_plan } = SelectedPlan();
    const {
      plan_phone_number,
      plan_hours_string,
      plan_brand_puct,
      plan_brand_legal_name,
      plan_brand_address,
      plan_brand_support_email,
      plan_brand_website
    } = Utilities();
    const expanded = ref(true);

    return {
      selected_plan,

      plan_phone_number,
      plan_brand_puct,
      plan_hours_string,
      plan_brand_legal_name,
      plan_brand_address,
      plan_brand_support_email,
      plan_brand_website,

      expanded
    }
  }
}
</script>

<style scoped>

</style>
